import { IApplicationConfiguration, IFrequency, TimeUnit } from '../../models/index';

export function getFreq(config: IApplicationConfiguration, frequency?: IFrequency): IFrequency {
    const freq: IFrequency = frequency && frequency.interval > 0
        ? frequency
        : getDefaultFreq(config);
    return freq;
}

export function getDefaultFreq(config: IApplicationConfiguration): IFrequency {
    return config
        ? { interval: config.interval, intervalTimeUnit: config.intervalTimeUnit }
        : { interval: 1, intervalTimeUnit: TimeUnit.Hour };
}